import { DatePipe } from '@angular/common';
import { Injectable, Pipe } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

const getDaysAgo = (date: Date): number => {
  const now = new Date();

  const dateOnly = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  const nowOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffMs = nowOnly.getTime() - dateOnly.getTime();
  return Math.floor(diffMs / 86400000);
};

type TransformOptions = {
  maxDaysAgo: number;
};

const defaultTransformOptions: TransformOptions = {
  maxDaysAgo: 7,
};

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'dateTimeRecent' })
export class DateTimeRecentPipe {
  constructor(
    private translate: TranslateService,
    private datePipe: DatePipe
  ) {}

  public transform(
    value: Date | string | number,
    options?: Partial<TransformOptions>
  ): { text: string; mapped: boolean } {
    const config = { ...defaultTransformOptions, ...options };

    const date = new Date(value);
    const time = this.datePipe.transform(date, 'HH:mm');

    const daysAgo = getDaysAgo(date);

    if (daysAgo === 0) {
      return {
        text: this.translate.instant('DATE_TIME_RECENT_PIPE.TODAY', { time }),
        mapped: true,
      };
    }
    if (daysAgo === 1) {
      return {
        text: this.translate.instant('DATE_TIME_RECENT_PIPE.YESTERDAY', {
          time,
        }),
        mapped: true,
      };
    }
    if (daysAgo <= config.maxDaysAgo) {
      return {
        text: this.translate.instant('DATE_TIME_RECENT_PIPE.N_DAYS_AGO', {
          days: daysAgo,
          time,
        }),
        mapped: true,
      };
    }

    return {
      text: this.datePipe.transform(
        date,
        environment.globalDateFormatWithTime
      )!,
      mapped: false,
    };
  }
}
